export default `
PORT=8000
NODE_ENV="development"
FRONTEND_URL="http://localhost:3000"
`;